import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import AppContext from 'context/Context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faHeadset,
  faThLarge,
  faTicketAlt,
  faTachometerAlt,
  faCog,
  faArrowLeft,
  faTimes
} from '@fortawesome/free-solid-svg-icons';

const SupportEngineSidebar = ({
  activeTab,
  setActiveTab,
  onSelectSettings,
  isOpen = false,
  onClose
}) => {
  const { config: { isDark } = {} } = useContext(AppContext);

  const topMenuItems = [
    { id: 'dashboard', label: 'Dashboard', icon: faThLarge, badge: null },
    { id: 'tickets', label: 'Lista de Tickets', icon: faTicketAlt, badge: null },
    { id: 'agents', label: 'Asesores', icon: faTachometerAlt, badge: null }
  ];

  const handleReturnToAdmin = () => {
    if (window.opener) {
      window.close();
    }
  };

  return (
    <aside
      className={`se-sidebar ${isOpen ? 'se-sidebar-open' : ''}`}
      style={{
        backgroundColor: isDark ? '#121e2d' : '#ffffff',
        borderColor: isDark ? '#233142' : '#e2e8f0'
      }}
    >
      {/* Brand Logo Header */}
      <div className="d-flex align-items-center gap-2 mb-4 pb-1">
        <div className="se-logo-box">
          <FontAwesomeIcon icon={faHeadset} size="lg" />
        </div>
        <div>
          <h6 className="fw-bold mb-0" style={{ fontSize: '1.05rem', lineHeight: 1.2, color: isDark ? '#f9fafd' : '#0f172a' }}>
            Support Engine
          </h6>
          <small className="text-muted" style={{ fontSize: '0.72rem', color: isDark ? '#94a3b8' : '#64748b' }}>
            Mesa de Ayuda
          </small>
        </div>

        {/* Botón cerrar visible solo en móvil */}
        <button
          type="button"
          className="btn btn-sm border-0 d-lg-none ms-auto rounded-circle d-flex align-items-center justify-content-center shadow-none"
          onClick={onClose}
          style={{
            width: '32px',
            height: '32px',
            backgroundColor: isDark ? '#1e293b' : '#f1f5f9',
            color: isDark ? '#94a3b8' : '#64748b'
          }}
          aria-label="Cerrar menú"
        >
          <FontAwesomeIcon icon={faTimes} />
        </button>
      </div>

      {/* Navigation Items */}
      <nav className="d-flex flex-column gap-1 flex-grow-1">
        {topMenuItems.map(item => {
          const isActive = activeTab === item.id;
          return (
            <button
              key={item.id}
              onClick={() => {
                setActiveTab(item.id);
                if (onClose) onClose();
              }}
              className={`se-nav-btn d-flex justify-content-between align-items-center ${isActive ? 'active' : ''}`}
            >
              <div className="d-flex align-items-center gap-2">
                <FontAwesomeIcon
                  icon={item.icon}
                  style={{
                    color: isActive ? (isDark ? '#818cf8' : '#4338ca') : (isDark ? '#94a3b8' : '#64748b'),
                    width: '18px'
                  }}
                />
                <span>{item.label}</span>
              </div>
              {item.badge && (
                <span
                  className="badge rounded-pill text-white"
                  style={{
                    backgroundColor: '#065f46',
                    fontSize: '0.7rem',
                    fontWeight: 700,
                    padding: '0.2rem 0.55rem'
                  }}
                >
                  {item.badge}
                </span>
              )}
            </button>
          );
        })}
      </nav>

      {/* Configuración */}
      <div className="mb-2">
        <button
          onClick={() => {
            if (onSelectSettings) {
              onSelectSettings();
            } else {
              setActiveTab('settings');
              if (onClose) onClose();
            }
          }}
          className={`se-nav-btn ${activeTab === 'settings' ? 'active' : ''}`}
        >
          <div className="d-flex align-items-center gap-2">
            <FontAwesomeIcon
              icon={faCog}
              style={{
                color: activeTab === 'settings' ? (isDark ? '#818cf8' : '#4338ca') : (isDark ? '#94a3b8' : '#64748b'),
                width: '18px'
              }}
            />
            <span>Configuración</span>
          </div>
        </button>
      </div>

      {/* Bottom Left Return Button */}
      <div className="pt-3 border-top" style={{ borderColor: isDark ? '#233142' : '#e2e8f0' }}>
        <Link
          to="/"
          onClick={() => {
            handleReturnToAdmin();
            if (onClose) onClose();
          }}
          className="se-nav-btn text-decoration-none d-flex align-items-center"
          title="Regresar a Akasia Admin Panel"
        >
          <FontAwesomeIcon
            icon={faArrowLeft}
            style={{ color: isDark ? '#94a3b8' : '#64748b', width: '18px' }}
          />
          <span style={{ fontSize: '0.85rem', color: isDark ? '#94a3b8' : '#64748b' }}>Volver al Admin</span>
        </Link>
      </div>
    </aside>
  );
};

export default SupportEngineSidebar;
